import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "supplier_partner_projects",
    pageTitle: "SP-Projects",
    displayName: "SP-Projects",
    columns,
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
